import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import {
  PositionActionRequest,
  PositionActionResponse,
} from '../models/position-action.model'
import { PositionsTaskService } from './positions-task.service'

/**
 * Stand-in for the actions endpoint. NO LONGER THE BOUND IMPLEMENTATION — the panel now dispatches
 * through {@link HttpPositionsTaskService} (see {@link POSITION_ACTIONS_ENDPOINT_AVAILABLE}).
 *
 * Kept for two live uses: it is what every grid spec dispatches through (asserting `submitted` is
 * how the payload is pinned without an HTTP mock), and it is the fallback the flag selects if the
 * panel has to be demoed before helios !487 / !491 deploy.
 *
 * Accepts every action and resolves immediately, so the in-memory {@link MatchingService} mutation
 * still applies. It fabricates NO data — the positions workbench serves no invented rows — it only
 * fabricates the *acknowledgement* that the write succeeded.
 *
 * `submitted` records what was dispatched, in order. Unbounded by design: a stub's lifetime is one
 * panel instance.
 *
 * ⚠ SILENT SUCCESS: with this bound, clicking Match/Unmatch/Ignore changes the grids and persists
 * NOTHING; a reload shows the original state. That is why it is no longer the default.
 */
@Injectable()
export class StubPositionsTaskService extends PositionsTaskService {
  readonly submitted: PositionActionRequest[] = []

  submit(request: PositionActionRequest): Observable<PositionActionResponse> {
    this.submitted.push(request)
    // No commands: the stub creates none, and nothing in the UI branches on the list.
    return of({ commands: [] })
  }
}
